var $a859ce19c8ff962a$exports = {};
const $a859ce19c8ff962a$var$CARD = {
    R: 18,
    GAP: 16
};
function $a859ce19c8ff962a$var$buildRectPath(W, H, R) {
    return [
        `M ${R} 0`,
        `L ${W - R} 0`,
        `A ${R} ${R} 0 0 1 ${W} ${R}`,
        `L ${W} ${H - R}`,
        `A ${R} ${R} 0 0 1 ${W - R} ${H}`,
        `L ${R} ${H}`,
        `A ${R} ${R} 0 0 1 0 ${H - R}`,
        `L 0 ${R}`,
        `A ${R} ${R} 0 0 1 ${R} 0 Z`
    ].join(' ');
}
function $a859ce19c8ff962a$var$getCardConfig(W) {
    if (W < 640) return {
        R: 10,
        GAP: 0,
        mapWidthRatio: 0.48,
        mapHeightRatio: 0.51,
        notch: false
    };
    if (W < 900) return {
        R: 18,
        GAP: 16,
        mapWidthRatio: 0.5,
        mapHeightRatio: 0.5,
        notch: true
    };
    return {
        R: 18,
        GAP: 16,
        mapWidthRatio: 0.5,
        mapHeightRatio: 0.5,
        notch: true
    };
}
function $a859ce19c8ff962a$var$buildReversePath(W, H, CARD) {
    const cfg = $a859ce19c8ff962a$var$getCardConfig(W);
    const MAP_W = W * cfg.mapWidthRatio - cfg.GAP;
    const MAP_H = Math.min(W * cfg.mapHeightRatio * 17 / 16 - cfg.GAP, H - cfg.GAP * 2);
    if (!cfg.notch) // Mobile: simple rounded rect, no notch geometry needed
    return {
        d: $a859ce19c8ff962a$var$buildRectPath(W, H, cfg.R),
        MAP_W: MAP_W,
        MAP_H: MAP_H,
        MAP_LEFT: 0
    };
    const NOTCH_RIGHT = MAP_W + cfg.GAP; // right edge of the cut-out
    const NOTCH_BOTTOM = MAP_H + cfg.GAP; // bottom edge of the cut-out
    const d = [
        `M ${NOTCH_RIGHT + cfg.R} 0`,
        `L ${W - cfg.R} 0`,
        `A ${cfg.R} ${cfg.R} 0 0 1 ${W} ${cfg.R}`,
        `L ${W} ${H - cfg.R}`,
        `A ${cfg.R} ${cfg.R} 0 0 1 ${W - cfg.R} ${H}`,
        `L ${cfg.R} ${H}`,
        `A ${cfg.R} ${cfg.R} 0 0 1 0 ${H - cfg.R}`,
        `L 0 ${NOTCH_BOTTOM + cfg.R}`,
        `A ${cfg.R} ${cfg.R} 0 0 1 ${cfg.R} ${NOTCH_BOTTOM}`,
        `L ${NOTCH_RIGHT - cfg.R} ${NOTCH_BOTTOM}`,
        `A ${cfg.R} ${cfg.R} 0 0 0 ${NOTCH_RIGHT} ${NOTCH_BOTTOM - cfg.R}`,
        `L ${NOTCH_RIGHT} ${cfg.R}`,
        `A ${cfg.R} ${cfg.R} 0 0 1 ${NOTCH_RIGHT + cfg.R} 0 Z`
    ].join(' ');
    return {
        d: d,
        MAP_W: MAP_W,
        MAP_H: MAP_H,
        MAP_LEFT: 0
    }; // image card sits at x=0
}
const $a859ce19c8ff962a$var$serviceDesc = document.querySelector('.service-description');
const $a859ce19c8ff962a$var$imgCard = document.querySelector('.oc-mockup-img');
const $a859ce19c8ff962a$var$ocInfoSection = document.querySelector('.oc-info-section');
let $a859ce19c8ff962a$var$prevIsMobile = null;
function $a859ce19c8ff962a$var$reparentImgCard(isMobile) {
    if (isMobile === $a859ce19c8ff962a$var$prevIsMobile) return;
    $a859ce19c8ff962a$var$prevIsMobile = isMobile;
    if (isMobile) {
        $a859ce19c8ff962a$var$imgCard.style.position = 'static';
        $a859ce19c8ff962a$var$imgCard.style.alignSelf = 'center';
        $a859ce19c8ff962a$var$imgCard.style.background = "none";
        $a859ce19c8ff962a$var$imgCard.style.boxShadow = "none";
        $a859ce19c8ff962a$var$ocInfoSection.insertBefore($a859ce19c8ff962a$var$imgCard, $a859ce19c8ff962a$var$ocInfoSection.children[2]);
    } else {
        $a859ce19c8ff962a$var$serviceDesc.appendChild($a859ce19c8ff962a$var$imgCard);
        $a859ce19c8ff962a$var$imgCard.style.position = 'absolute';
        $a859ce19c8ff962a$var$imgCard.style.background = "linear-gradient(45deg, #ecf0f2 0%, #f7f8f9 100%)";
        $a859ce19c8ff962a$var$imgCard.style.boxShadow = "-8px -8px 20px var(--shadow-light), 8px 8px 20px var(--shadow-dark), inset -5px -5px 15px var(--shadow-light), inset 5px 5px 10px #aeaec040";
    }
}
function $a859ce19c8ff962a$var$applyGeometry(W, H) {
    const { d: d, MAP_W: MAP_W, MAP_H: MAP_H, MAP_LEFT: MAP_LEFT } = $a859ce19c8ff962a$var$buildReversePath(W, H, $a859ce19c8ff962a$var$CARD);
    // Reverse card clip
    const reverseCardRoot = document.querySelector('.oc-reverse-card');
    if (reverseCardRoot) reverseCardRoot.style.clipPath = `path("${d}")`;
    // Single SVG path — convex-bubble filter only
    const shadowPath = document.getElementById('oc-insetLightPath');
    if (shadowPath) shadowPath.setAttribute('d', d);
    // SVG canvas sizing
    const svg = document.getElementById('oc-inset-svg');
    if (svg) {
        svg.setAttribute('width', W);
        svg.setAttribute('height', H);
    }
    // Mockup image position + size
    if ($a859ce19c8ff962a$var$imgCard) {
        $a859ce19c8ff962a$var$imgCard.style.left = `${MAP_LEFT}px`;
        $a859ce19c8ff962a$var$imgCard.style.width = `${MAP_W}px`;
        $a859ce19c8ff962a$var$imgCard.style.height = `${MAP_H}px`;
    }
}
const $a859ce19c8ff962a$var$ro = new ResizeObserver((entries)=>{
    const { width: width, height: height } = entries[0].contentRect;
    const isMobile = width < 640; // stays in sync with getCardConfig's own threshold
    $a859ce19c8ff962a$var$reparentImgCard(isMobile);
    $a859ce19c8ff962a$var$applyGeometry(width, height); // always runs now
});
$a859ce19c8ff962a$var$ro.observe($a859ce19c8ff962a$var$serviceDesc);


//# sourceMappingURL=web-build.99e6d8e3.js.map
